module.exports = __webpack_public_path__ + "img/de.7f92db41.png";